// Shared enums + types for the onboarding question editor. Kept in sync with the
// backend V2 contract (backend/src/routes/questions.ts CreateQuestionInput +
// onboarding.questions CHECK constraints).

export const RESPONSE_MODES = ['single_select', 'multi_select', 'free_text', 'rank'] as const;
export type ResponseMode = (typeof RESPONSE_MODES)[number];

export const DIMENSIONS = [
  'values', 'lifestyle', 'attachment', 'communication', 'intimacy', 'demographic', 'narrative',
] as const;
export type Dimension = (typeof DIMENSIONS)[number];

export const STATUSES = ['active', 'draft', 'archived'] as const;
export type QuestionStatus = (typeof STATUSES)[number];

export const ROUNDS = [1, 2, 3] as const;

/** response_modes that use options (label list). free_text/rank don't. */
export const OPTION_MODES: ResponseMode[] = ['single_select', 'multi_select'];

export interface Section {
  id: string;
  slug: string;
  title: string;
  section_order: number;
}

export interface QuestionOption {
  option_id?: string;        // present when loaded from edit; absent for new rows
  option_text: string;
  option_text_es?: string | null;
  synonyms?: string[];
  synonyms_es?: string[];
  display_order?: number;
  image_url?: string | null;
}

export interface QuestionListRow {
  id: string;
  legacy_q_number: string;
  question_text: string;
  response_mode: ResponseMode;
  round: number;
  weight: number;
  status: QuestionStatus;
  dimension: Dimension | null;
  section_title: string;
  section_slug: string;
  option_count: number;
  updated_at: string;
}

export interface QuestionDetail extends QuestionListRow {
  question_text_es: string | null;
  main_number: number;
  sub_number: number | null;
  question_order: number;
  section_id: string;
  show_summary_after: boolean;
  is_suggested: boolean;
  options: QuestionOption[];
}

const STATUS_BADGE: Record<QuestionStatus, string> = {
  active: 'bg-green-500/15 text-green-700 dark:text-green-400',
  draft: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  archived: 'bg-muted text-muted-foreground',
};
export const statusBadgeClass = (s: string): string => STATUS_BADGE[s as QuestionStatus] ?? 'bg-muted text-muted-foreground';
